import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const ContactsListItemParts = ['container', 'text'] as const

const helpers = createMultiStyleConfigHelpers(ContactsListItemParts)

export const ContactsListItemStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '3.25rem',
      width: '100%',
      padding: '0.75rem',
      mb: '0.5rem',
      borderRadius: '0.5rem',
      cursor: 'pointer',
      backgroundColor: 'bg.default',
      _hover: {
        backgroundColor: 'bg.subtle',
      },
      '&[data-active]': {
        backgroundColor: 'bg.muted',
      },
    },
    text: {
      ...textStyles[textStyleKeys.Body1],
      maxWidth: 'calc(100% - .5rem)',
      color: 'fg.muted',
      _hover: {
        color: 'fg.default',
      },
      '[data-active] &': {
        color: 'fg.default',
      },
    },
  },
})

export const useContactsListItemStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(ContactsListItemStyle, props) as MultiStyleType<
    typeof ContactsListItemParts
  >
}
